import { decodeError } from '../utility/errors';

const INITIAL_STATE = {
  errors: []
};

const types = {
  ERROR_OCCURRED: 'orb/staticData/ERROR_OCCURRED',
  CLEAR_ERRORS: 'orb/staticData/CLEAR_ERRORS'
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.ERROR_OCCURRED:
      return Object.assign({}, state, {
        errors: state.errors.concat(action.error)
      });
    case types.CLEAR_ERRORS:
      return Object.assign({}, state, {
        errors: []
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;

export function errorOccurred(error, context) {
  const detail = decodeError(error);

  return {
    type: types.ERROR_OCCURRED,
    error: {
      context,
      message: detail.message
    }
  };
}

export function clearErrors() {
  return {
    type: types.CLEAR_ERRORS
  };
}



// WEBPACK FOOTER //
// ./src/errors/reducer.js